import { appEnv } from '../lib/env';
import { FaExclamationCircle } from 'react-icons/fa';

export function NotFoundPage() {
  return (
    <div className="main-container">
      <div className="main-container-top" style={{ alignItems: 'center', textAlign: 'center' }}>
        <FaExclamationCircle size={64} color="#F50000" style={{ marginBottom: '16px' }} />
        <h2 style={{ color: '#F50000' }}>404 Not Found</h2>
        <p className="main-text">The page you are looking for does not exist or has been moved.</p>
      </div>
      <a href={appEnv.logoFrontendUrl} className="btn-link">
        <button className="secondary">
          <span />
          <span>HOME</span>
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
      </a>
    </div>
  );
}
